import { useStepperContext } from "../StepperContext";
import { useBatteryOptions } from "../../../hooks/use-battery-options";
import BRCSelect from "./BRCSelect";



const portalStyles = {
  menuPortal: (base) => ({ ...base, zIndex: 1500 }),
};

const InBatterySelect = ({ disabled = false }) => {
  const { data, updateData } = useStepperContext();
  const { options, assignedLength, isLoading } = useBatteryOptions(
    data.driverId,
  );

  return (
    <BRCSelect
      label="Select inserted battery ID:"
      options={options}
      value={
        options.find((option) => option.value === data.insertedBatteryId) ||
        null
      }
      onChange={(selectedOption) =>
        updateData("insertedBatteryId", selectedOption?.value || "")
      }
      isLoading={isLoading}
      isDisabled={disabled}
      assignedBatteriesLength={assignedLength}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      styles={portalStyles}
    />
  );
};

export default InBatterySelect;